import React from "react";
// local
import {listLanguageKey} from "../../constants";

export const SignContractOurProfileHead = ({isOwner, t}) => (
  <div className="modal-our-profiles__table-head">
    <div className="modal-our-profiles__table-head-name">
      {t(`${listLanguageKey}HEAD_NAME`)}
    </div>

    <div className="modal-our-profiles__table-head-reference">
      {t(`${listLanguageKey}HEAD_REFERENCE`)}
    </div>
    <div className="modal-our-profiles__table-head-company">
      {t(`${listLanguageKey}HEAD_COMPANY`)}
    </div>
    <div className="modal-our-profiles__table-head-number">
      {t(`${listLanguageKey}HEAD_NUMBER`)}
    </div>
    {isOwner && <div className="modal-our-profiles__table-head-actions"></div>}
  </div>
);
